export type FailureStrategyType = 'FAIL' | 'IGNORE' | 'RETRY';

export class FailureStrategy {
  strategy: FailureStrategyType;

  constructor(strategy: FailureStrategyType) {
    this.strategy = strategy;
  }
}

export class RetryFailureStrategy extends FailureStrategy {
  currentRetryCount: number;
  maxRetryCount: number;
  previousStepRuns: string[];
  durationInSecondsFromPreviousRetries: number;
  buildSecondsUsedFromPreviousRetries: number;

  constructor(
    strategy: 'RETRY',
    currentRetryCount: number,
    maxRetryCount: number,
    previousStepRuns: string[],
    durationInSecondsFromPreviousRetries: number,
    buildSecondsUsedFromPreviousRetries: number
  ) {
    super(strategy);
    this.currentRetryCount = currentRetryCount;
    this.maxRetryCount = maxRetryCount;
    this.previousStepRuns = previousStepRuns;
    this.durationInSecondsFromPreviousRetries =
      durationInSecondsFromPreviousRetries;
    this.buildSecondsUsedFromPreviousRetries =
      buildSecondsUsedFromPreviousRetries;
  }
}

export class IgnoreRetryFailureStrategy extends FailureStrategy {
  constructor(strategy: 'IGNORE') {
    super(strategy);
  }
}
